const Cars = [
  {
    automatic: false,
    group: "A",
    name: "Toyota Vitz",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: false,
      ABS: false,
      powerSteering: false
    },
    engineCapacity: "1.0L/1.2L",
    doors: 5,
    seats: 4,
    style: "hatch",
    mileagePrice: 3.56,
    defaultDailyCharge: 374,
    superDailyCharge: 441,
    expressDailyCharge: 565,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "B",
    automatic: false,
    name: "Toyota Starlet",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.2L/1.4L/1.5L",
    seats: 5,
    doors: 5,
    style: "hatch",
    mileagePrice: 3.61,
    defaultDailyCharge: 404,
    superDailyCharge: 473,
    expressDailyCharge: 597,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "B1",
    automatic: false,
    name: "VW Polo Vivo",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.3L/1.5L/1.6L",
    seats: 5,
    doors: 5,
    style: "hatch",
    mileagePrice: 3.79,
    defaultDailyCharge: 474,
    superDailyCharge: 513,
    expressDailyCharge: 628,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "C2",
    automatic: false,
    name: "Toyota Corolla",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.3L/1.5L/1.6L",
    seats: 5,
    doors: 5,
    style: "hatch/sedan",
    mileagePrice: 3.74,
    defaultDailyCharge: 441,
    superDailyCharge: 490,
    expressDailyCharge: 617,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "D",
    automatic: true,
    name: "Toyota Starlet",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.4L/1.5L/1.6L",
    seats: 5,
    doors: 5,
    style: "hatch",
    mileagePrice: 4.87,
    defaultDailyCharge: 530,
    superDailyCharge: 561,
    expressDailyCharge: 690,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "E",
    automatic: true,
    name: "Toyota Corolla Quest",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.6L/1.8L",
    seats: 5,
    doors: 5,
    style: "sedan",
    mileagePrice: 5.26,
    defaultDailyCharge: 759,
    superDailyCharge: 819,
    expressDailyCharge: 996,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "Z",
    automatic: true,
    name: "Toyota Corolla Cross",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.4L/1.6L",
    seats: 5,
    doors: 5,
    style: "suv",
    mileagePrice: 6.00,
    defaultDailyCharge: 1429,
    superDailyCharge: 1638,
    expressDailyCharge: 1823,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "K",
    automatic: true,
    name: "Toyota Urban Cruiser",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.6L/2.0L/2.4L",
    doors: 5,
    seats: 5,
    style: "suv",
    mileagePrice: 6.92,
    defaultDailyCharge: 1123,
    superDailyCharge: 1437,
    expressDailyCharge: 1609,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "KM",
    automatic: false,
    name: "Toyota Urban Cruiser",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.6L/2.0L/2.4L",
    doors: 5,
    seats: 5,
    style: "suv",
    mileagePrice: 6.00,
    defaultDailyCharge: 719,
    superDailyCharge: 819,
    expressDailyCharge: 989,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "L",
    automatic: true,
    name: "Haval Jolion",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.6L/1.8L",
    doors: 4,
    seats: 5,
    style: "suv",
    mileagePrice: 7.12,
    defaultDailyCharge: 1510,
    superDailyCharge: 1616,
    expressDailyCharge: 1799,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "N",
    automatic: true,
    name: "VW T-Roc",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.6L/1.8L",
    doors: 4,
    seats: 5,
    style: "suv",
    mileagePrice: 7.12,
    defaultDailyCharge: 2027,
    superDailyCharge: 2126,
    expressDailyCharge: 2308,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "G",
    automatic: true,
    name: "Merc C Class",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.6L/1.8L",
    doors: 4,
    seats: 5,
    style: "sedan",
    mileagePrice: 8.50,
    defaultDailyCharge: 2199,
    superDailyCharge: 2362,
    expressDailyCharge: 2583,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "G1",
    automatic: true,
    name: "Audi Q5 Sportback",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.8L/2.0L",
    doors: 4,
    seats: 5,
    style: "suv",
    mileagePrice: 8.85,
    defaultDailyCharge: 2324,
    superDailyCharge: 2464,
    expressDailyCharge: 2841,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "G2",
    automatic: true,
    name: "BMW X3",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.8L/2.0L",
    doors: 4,
    seats: 5,
    style: "suv",
    mileagePrice: 8.85,
    defaultDailyCharge: 2567,
    superDailyCharge: 2708,
    expressDailyCharge: 3087,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "I",
    automatic: false,
    name: "Toyota Avanza",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.5L/1.6L",
    seats: 5,
    doors: 5,
    style: "5/7 seater",
    mileagePrice: 6.55,
    defaultDailyCharge: 1056,
    superDailyCharge: 1178,
    expressDailyCharge: 1250,
    excess: {
      standard: "7 000",
      super: "7 000",
      expressLane: "6 600"
    }
  },
  {
    group: "M",
    automatic: true,
    name: "Audi A3",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    engineCapacity: "1.4L/1.6L",
    doors: 4,
    seats: 5,
    style: "suv",
    mileagePrice: 8.50,
    defaultDailyCharge: 1973,
    superDailyCharge: 2189,
    expressDailyCharge: undefined,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "Q",
    name: "VW T5 / T6",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    automatic: true,
    engineCapacity: "2L/2.2L/2.4L",
    doors: 4,
    seats: 8,
    style: "8 seater",
    mileagePrice: 10.13,
    defaultDailyCharge: 2282,
    superDailyCharge: 2547,
    expressDailyCharge: 2778,
    excess: {
      standard: "8 000",
      super: "8 000",
      expressLane: "8 000"
    }
  },
  {
    group: "N1",
    name: "Double cab bakkie 4x4",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    automatic: false,
    engineCapacity: "2L/2.2L/2.4L",
    doors: 4,
    seats: 4,
    style: "4x4",
    mileagePrice: 11.09,
    defaultDailyCharge: 1442,
    superDailyCharge: 1543,
    expressDailyCharge: 2255,
    excess: {
      standard: "10 500",
      super: "10 500",
      expressLane: "17 500"
    }
  },
  {
    group: "N2",
    name: "Double cab bakkie 4x4",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    automatic: true,
    engineCapacity: "2L/2.2L/2.4L",
    doors: 4,
    seats: 4,
    style: "4x4",
    mileagePrice: 11.09,
    defaultDailyCharge: 2202,
    superDailyCharge: 2289,
    expressDailyCharge: 2415,
    excess: {
      standard: "10 500",
      super: "10 500",
      expressLane: "10 500"
    }
  },
  {
    group: "TF",
    name: "Toyota Fortuner 4x2",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    automatic: true,
    engineCapacity: "2L/2.2L/2.4L",
    doors: 4,
    seats: 5,
    style: "4x2 SUV",
    mileagePrice: 11.66,
    defaultDailyCharge: 2058,
    superDailyCharge: 2151,
    expressDailyCharge: 2361,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "T2",
    name: "Toyota Fortuner 4x4",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    automatic: true,
    engineCapacity: "2L/2.2L/2.4L",
    doors: 4,
    seats: 5,
    style: "4x4 SUV",
    mileagePrice: 11.66,
    defaultDailyCharge: 2162,
    superDailyCharge: 2243,
    expressDailyCharge: 2451,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "H",
    name: "1 Ton Single Cab",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    automatic: false,
    engineCapacity: "2L/2.2L/2.4L",
    doors: 2,
    seats: 2,
    style: "without canopy",
    mileagePrice: 4.80,
    defaultDailyCharge: 830,
    superDailyCharge: 947,
    expressDailyCharge: 1023,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "4 500"
    }
  },
  {
    group: "J",
    name: "1 Ton Single Cab",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    automatic: false,
    engineCapacity: "2L/2.2L/2.4L",
    doors: 2,
    seats: 2,
    style: "with canopy",
    mileagePrice: 4.80,
    defaultDailyCharge: 867,
    superDailyCharge: 990,
    expressDailyCharge: 1065,
    excess: {
      standard: "6 500",
      super: "5 000",
      expressLane: "5 000"
    }
  },
  {
    group: "O",
    name: "Toyota Quantum",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    automatic: false,
    engineCapacity: "2L/2.2L/2.4L",
    doors: 3,
    seats: 14,
    style: "14 Seater",
    mileagePrice: 10.89,
    defaultDailyCharge: 3183,
    superDailyCharge: 3326,
    expressDailyCharge: 3355,
    excess: {
      standard: "15 500",
      super: "15 500",
      expressLane: "15 000"
    }
  },
  {
    group: "Y",
    name: "Toyota Quantum",
    details: {
      radioAndCD: true,
      aircon: true,
      airbags: true,
      ABS: true,
      powerSteering: true
    },
    automatic: false,
    engineCapacity: "2L/2.2L/2.4L",
    doors: 3,
    seats: 11,
    style: "11 Seater",
    mileagePrice: 10.89,
    defaultDailyCharge: 2362,
    superDailyCharge: 2782,
    excess: {
      standard: "9 000",
      super: "9 000",
      expressLane: "8 500"
    }
  }
];

export { Cars };
